import { GlobalResponseObject } from '../../../common';
import { BiMessageModel } from './bi-message.model';

export class BiMessageResponse extends GlobalResponseObject {
    data?: BiMessageModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: BiMessageModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}